import type { ReferentialUserState } from "./referential-user-states.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential } from "@/entities/referential";
import { REFERENTIAl_STATES_ENDPOINT } from "@/entities/referential/referential-states";

export const useReferentialUserStates = (
  options?: UseReferentialOptions<ReferentialUserState[]>
) => {
  const { data: userStates = [], ...result } = useReferential<
    ReferentialUserState[]
  >(REFERENTIAl_STATES_ENDPOINT.USER, options);

  return {
    ...result,
    userStates,
  };
};
